import React, { useContext } from 'react';
import './PageStatut.css';
import logoCentralis from '../../assets/logo/logo-centralis-gris.svg';
import { useAuth } from '../../contexts/AuthContext';
import MainLayout from '../../Layout/MainLayout';
import { InsideLayoutContext } from '../../Layout/layoutContext';

interface PageStatutProps {
  /** Code HTTP affiche en gros (ex "404", "503"). Optionnel (ex. maintenance). */
  code?: string;
  titre: string;
  message: React.ReactNode;
  /** Boutons d'action (Retour accueil, Se connecter...). */
  actions?: React.ReactNode;
  variant?: 'erreur' | 'maintenance';
  /**
   * Enrobe la page de la navbar applicative quand l'utilisateur est connecte (defaut: true).
   * Mettre false pour la page 500 rendue par l'ErrorBoundary : re-monter tout le layout
   * (navbar, contextes) pourrait re-declencher le crash a l'origine de l'erreur.
   */
  avecNavbar?: boolean;
}

/**
 * Page d'etat, charte Centralis. Reutilisee par toutes les pages d'erreur (404/403/401/500)
 * et la maintenance applicative.
 *
 * Connecte -> enrobee du MainLayout (navbar visible, l'utilisateur peut naviguer).
 * Non connecte -> page plein ecran autonome (pas de navbar).
 */
const PageStatut: React.FC<PageStatutProps> = ({ code, titre, message, actions, variant = 'erreur', avecNavbar = true }) => {
  const { user } = useAuth();
  const insideLayout = useContext(InsideLayoutContext);
  // Enrober d'un MainLayout seulement si connecte ET pas deja dans un layout (sinon double navbar -> crash).
  const avecChrome = avecNavbar && !!user && !insideLayout;
  const dansLayout = avecChrome || insideLayout; // -> styles "embedded" (pas plein viewport)

  const contenu = (
    <div className={`page-statut page-statut--${variant}${dansLayout ? ' page-statut--embedded' : ''}`}>
      <div className="page-statut-card">
        <img src={logoCentralis} alt="Centralis" className="page-statut-logo" />
        {code && <div className="page-statut-code">{code}</div>}
        <h1 className="page-statut-titre">{titre}</h1>
        <div className="page-statut-message">{message}</div>
        {actions && <div className="page-statut-actions">{actions}</div>}
      </div>
    </div>
  );

  return avecChrome ? <MainLayout>{contenu}</MainLayout> : contenu;
};

export default PageStatut;
